import { ITypedOptionList } from "./option-list";
import { TypedOptionListBase } from "./option-list-base";
import { OptionListType } from "./option-list-type";
import { IFlatOptionListValue } from "./option-list-value";

export type IFlatOptionList = ITypedOptionList<IFlatOptionListValue>;

export default class FlatOptionList extends TypedOptionListBase<IFlatOptionListValue> implements IFlatOptionList {
    readonly type: OptionListType = OptionListType.Flat;
}

export { FlatOptionList };
